"use client"

import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig, WhyChooseUsProps } from "./RenderConfig"

export const WhyChooseUs: ComponentConfig<WhyChooseUsProps> = {
  label: "CaoCao | Why Choose Us",
  //@ts-ignore
  fields: {
    features: {
      label: "Features",
      type: "array",
      min: 1,
      getItemSummary: (item, index = 0) => `${index + 1}. ${item?.title || "Feature"}`,
      arrayFields: {
        icon: {
          label: "Icon",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        activeIcon: {
          label: "Active Icon",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        description: {
          label: "Description",
          type: "textarea",
        },
        image: {
          label: "Feature Image",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    features: [
      {
        icon: "",
        activeIcon: "",
        title: "Lorem ipsum dolor sit amet",
        description: "Your tour will be carefully personalized to your wishes, needs and budgets.",
        image: "",
      },
      {
        icon: "",
        activeIcon: "",
        title: "Lorem ipsum dolor sit amet",
        description: "Your tour will be carefully personalized to your wishes, needs and budgets.",
        image: "",
      },
      {
        icon: "",
        activeIcon: "",
        title: "Lorem ipsum dolor sit amet",
        description: "Your tour will be carefully personalized to your wishes, needs and budgets.",
        image: "",
      },
      {
        icon: "",
        activeIcon: "",
        title: "Lorem ipsum dolor sit amet",
        description: "Your tour will be carefully personalized to your wishes, needs and budgets.",
        image: "",
      },
    ],
    className: "",
  },
  ...RenderConfig,
}
